import { Head } from "@shared/components/head";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { ActivityCompleteCard } from "app/_modules/core/components/home";
import { IPathwayActivitiesResponse, IPathwayActivity } from "app/_modules/pathways/entities";
import { Text, TouchableOpacity, View } from "react-native";
import { ActivityType } from "app/_modules/pathways/entities";
import { ACTIVITY_STATUS } from "app/_modules/core/constants";
import { hasActivityTimePassed } from "@shared/utils/timeOfDay";
import { generateActivityTitleTranslation } from "@shared/utils/dynamicTranslation";


export const HistoryActivitySection = ({ activities, isToday = false }: { activities: IPathwayActivitiesResponse, isToday?: boolean }) => {
    const { t } = dynamicTranslations();

    const allCompletedActivities: IPathwayActivity[] = [];
    const allIncompleteActivities: IPathwayActivity[] = [];

    Object.entries(activities)
        .filter(([key, value]) => key !== "date" && Array.isArray(value) && value.length > 0)
        .forEach(([timeOfDay, activitiesList]) => {
            activitiesList.forEach((activity: IPathwayActivity) => {
                if (activity.status === ACTIVITY_STATUS.COMPLETED) {
                    allCompletedActivities.push(activity);
                } else {
                    if (!isToday) {
                        allIncompleteActivities.push(activity);
                    } else {
                        const timeHasPassed = hasActivityTimePassed(timeOfDay);
                        if (timeHasPassed) {
                            allIncompleteActivities.push(activity);
                        }
                    }
                }
            });
        });

    const renderIncompleteActivity = (activity: IPathwayActivity) => (
        <TouchableOpacity
            key={activity.activityId}
            disabled={true}
            className="bg-gray-100 rounded-3xl p-6 mb-2"
        >
            <Text className="text-gray-500 font-bold text-base">
                {t(generateActivityTitleTranslation(activity.activityName, activity.activityType))}
            </Text>
        </TouchableOpacity>
    );

    return (
        <View className={`flex-col gap-2`}>
            {allCompletedActivities.map((activity) => (
                <ActivityCompleteCard key={activity.activityId} activity={activity} allowPress={false} />
            ))}

            {allIncompleteActivities.length > 0 && (
                <>
                    <Head type="h3">{t('screens.activities.whatYouForgot')}</Head>
                    {allIncompleteActivities.map(renderIncompleteActivity)}
                </>
            )}
        </View>
    )
}
